module.exports = __webpack_public_path__ + "img/greenpeace.dd6ff32.png";